<template>
  <div class="product-detail">
    <van-image :src="pageData.goodsUrlImage" class="p-img" />
    <div class="title">
      <p class="name">{{pageData.goodsName}}</p>
      <div class="fx fx-between">
        <p class="price-box">
          <span>{{pageData.currency | unitFormat}}{{pageData.priceReal | numFormat(2)}} </span>
          <span
            class="line-through gray" v-if="pageData.priceReal != pageData.priceSale">{{pageData.currency | unitFormat}}{{pageData.priceSale | numFormat(2)}}</span>
        </p>
        <div class="stepper fx">
          <button class="van-stepper__minus" :class="addCartParams.goodsList[0].goodsNum < 2 ? 'disabled' : ''" @click="onMinusTap"></button>
          <span class="num">{{currentNum}}</span>
          <button class="van-stepper__plus" @click="onPlusTap"></button>
        </div>
      </div>
    </div>
    <div class="info">
      <div class="group">
        <p>Description</p>
        <p class="text gray" style="word-wrap: break-word;" v-html="pageData.description"></p>
      </div>
      <div class="group">
        <p>Instructions</p>
        <p class="text gray" style="word-wrap: break-word;" v-html="pageData.instructions"></p>
      </div>
    </div>
    <div class="btn">
      <van-button type="info" size="large" round @click="onBuyTap(isDisabled = true)" :disabled="isDisabled">Place Order
        ({{pageData.currency | unitFormat}} {{totalAmount | numFormat(2)}})
      </van-button>
    </div>
  </div>
</template>

<script src="https://cdn.jsdelivr.net/npm/lodash@4.13.1/lodash.min.js"></script>
<script>
  import _ from 'lodash'
  export default {
    data() {
      return {
        loading: true,
        popupData: {
          isShow: false,
          text: 'System is busy, please try again later.',
          btn: 'OK'
        },
        pageData: {},
        getDetailParams: {
          token: '',
          goodsId: null
        },
        addCartParams: {
          clearCart: 'Yes',
          token: '',
          goodsList: [{
            goodsId: '',
            goodsNum: 1,
            checkStatus: 'Checked'
          }]
        },
        createOrderParams: {
          token: '',
          memberId: '',
          orderUrlImage: '',
          goodsList: []
        },
        defaultInit: true,
        totalAmount: '0.00',
        isDisabled: false,
        currentNum: 1
      }
    },
    created() {
      const queryParams = this.$route.query
      const token = this.$util.storageGet('local', 'token') || ''
      if (token) {
        this.getDetailParams.token = token
        this.addCartParams.token = token
        this.createOrderParams.token = token
      }
      this.getDetailParams.goodsId = queryParams.goodsId
      this.loadData()
    },
    methods: {
      // 获取商品详情
      getGoodsDetail(params) {
        return this.$http.post('/olvp/getGoodsDetail', 'getGoodsDetail', params, false, false)
      },
      // 添加购物车 （修改购买数量）
      addCartGoods(params) {
        return this.$http.post('/olvp/addCartGoods', 'addCartGoods', params, false, false)
      },
      // 创建订单
      createOrder(params) {
        return this.$http.post('/olvp/createOrder', 'createOrder', params, false, false)
      },
      // 页面数据加载
      loadData() {
        this.getGoodsDetail(this.getDetailParams).then((d) => {
          if (d.success) {
            if (d.content.marketId != this.$util.storageGet('local', 'marketId')) {
              this.$router.replace('/home')
            }
            this.pageData = d.content
            this.totalAmount = this.pageData.priceReal
            this.addCartParams.goodsList[0].goodsId = this.pageData.goodsId
            if (d.content.goodsUrlImage) {
              this.pageData.goodsUrlImage = JSON.parse(d.content.goodsUrlImage)[0].url
            }
            this.loading = false
          }
        })
      },
      // 减号
      onMinusTap: _.debounce(
        function () {
          if (this.addCartParams.goodsList[0].goodsNum === 1) {
            return false
          }
          this.addCartParams.goodsList[0].goodsNum = this.currentNum - 1
          this.addCartGoods(this.addCartParams).then((d) => {
            if (d.success) {
              this.currentNum = this.addCartParams.goodsList[0].goodsNum
              this.createOrderParams.goodsList[0] = d.content.goodsList[0]
              this.totalAmount = d.content.goodsList[0].totalAmount
            }
          })
        },
        500
      ),
      // 加号
      onPlusTap: _.debounce(
        function () {
          const token = this.$util.storageGet('local', 'token') || ''
          if (!token) {
            this.$cux.confirm({
              message: 'Please login to proceed.',
              confirmButtonText: 'Sign-up/Login',
              cancelButtonText: 'Cancel'
            }).then(() => {
              this.$router.push(`/login?backPath=${encodeURIComponent(this.$route.fullPath)}`)
            })
          } else {
            this.addCartParams.goodsList[0].goodsNum = this.currentNum + 1
            this.defaultInit = false
            this.addCartGoods(this.addCartParams).then((d) => {
              if (d.success) {
                this.currentNum = this.addCartParams.goodsList[0].goodsNum
                this.createOrderParams.goodsList[0] = d.content.goodsList[0]
                this.totalAmount = d.content.goodsList[0].totalAmount
              }
            })
          }
        },
        500
      ),
      onBuyTap: _.debounce(
        function () {
          this.$util.storageDel('session', 'giftImg')
          this.$util.storageDel('session', 'giftDesc')
          const token = this.$util.storageGet('local', 'token') || ''
          if (!token) {
            this.$cux.confirm({
              message: 'Please login to proceed.',
              confirmButtonText: 'Sign-up/Login',
              cancelButtonText: 'Cancel'
            }).then(() => {
              this.isDisabled = false
              this.$router.push(`/login?backPath=${encodeURIComponent(this.$route.fullPath)}`)
            })
        } else {
          if (this.defaultInit) {
            this.addCartGoods(this.addCartParams).then((d) => {
                if (d.success) {
                  this.createOrderParams.goodsList[0] = d.content.goodsList[0]
                  this.createOrderParams.memberId = d.content.goodsList[0].memberId
                  this.createOrder(this.createOrderParams).then((d) => {
                    if (d.success) {
                      this.$router.push(
                        `/orderDetail?type=${'pay'}&orderId=${d.content.orderId}`
                      )
                    }
                    this.isDisabled = false
                  })
                }
              })
          } else {
            this.createOrder(this.createOrderParams).then((d) => {
              if (d.success) {
                this.$router.push(
                  `/orderDetail?type=${'pay'}&orderId=${d.content.orderId}`
                )
                this.isDisabled = false
              }
            })
          }
        }
        },
        500
      )
    }
  }
</script>

<style lang="scss">
  .product-detail {
    width: 100%;
    height: 100%;
    padding: 15px;
    .p-img {
      width: 100%;
    }

    .title {
      padding-top: 15px;
      padding-bottom: 15px;
      border-bottom: 1px solid #eee;

      .name {
        font-size: 17px;
        margin-bottom: 4px;
      }
    }

    .info {
      padding: 10px 0 80px 0px;

      .bold {
        margin-bottom: 5px;
        font-size: 16px;
      }

      .group {
        padding-bottom: 15px;

        .text {
          line-height: 20px;
          margin-top: 8px;
        }

        .date {
          margin-bottom: 10px;
        }
      }

      .group:nth-child(1) .bold {
        margin-top: 0;
      }

      .group:nth-child(3) {
        border: none;
        padding-bottom: 0;
      }
    }

    .btn {
      max-width: 480px;
      padding: 20px;
      background: #fff;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
    }

    .pupup-content {
      text-align: center;
      font-size: 19px;
      line-height: 25px;

      .van-button {
        margin-top: 20px;
        width: 120px;
      }
    }

    .stepper {
      button {
        border-radius: 50%;
        border: 1px solid #1989fa;
      }

      .van-stepper__plus {
        color: #fff;
        background: #1989fa;
      }

      .van-stepper__minus {
        color: #1989fa;
        background: transparent;
      }

      .van-stepper__minus.disabled {
        border-color: #ccc;
        color: #ccc;
      }

      align-items: center;

      .num {
        margin: 0 8px;
        font-size: 16px;
      }
    }
  }
</style>
